(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dhw-product"]) return;
  try {
    document.querySelectorAll('.hw-gallery-shell').forEach(shell=>{const gallery=shell.querySelector('[data-hw-gallery]');shell.querySelectorAll('[data-hw-photo]').forEach(button=>button.addEventListener('click',()=>gallery.scrollTo({left:Number(button.dataset.hwPhoto)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})))});
  } catch(e) { console.error(e); }
})();
})();
